
const TotalExperience = () => {
        const startDateStr= "2022-08-18"; 
        const startDate = new Date(startDateStr);
        const today = new Date();
      
        let years = today.getFullYear() - startDate.getFullYear();
        let months = today.getMonth() - startDate.getMonth();
      
        if (months < 0) {
          years--;
          months += 12;
        }
      
        return { years, months };
      }

export default TotalExperience
